module.exports = __webpack_public_path__ + "img/26f9f32.jpg";